import axios from "../../utils/axiosInstance";

export const setAIFirewallPolicies = async (zenGroupId, policies, preventUsage, policyReportMode, aiToolAction) => {
    return await axios.post("/setAIFirewallPolicies", {
        zenGroupId: zenGroupId,
        policies: policies,
        preventUsage: preventUsage,
        policyReportMode: policyReportMode,
        aiToolAction: aiToolAction
    });
};
export const deleteAIFirewallPolicy = async (zenGroupId, aiFirewallVariant, aiFirewallProtection) => {
    return await axios.post("/deleteAIFirewallPolicy", {
        zenGroupId: zenGroupId,
        aiFirewallVariant: aiFirewallVariant,
        aiFirewallProtection: aiFirewallProtection
    });
};